const NS = 'NewsroomBlock';
const CLS = 'newsroomBlock';

export class NewsroomBlock {
	constructor($el) {
		this.$el = $($el);

		this.$cards = this.$el.find(`.${CLS}-card`);
		this.$cardCheckboxInputs = this.$cards.find(`.${CLS}-card-checkbox-input`);

		this.$cards.on('click', (event) => {
			let $card = $(event.currentTarget);
			let $checkbox = $card.find(`.${CLS}-card-checkbox-input`);
			let isChecked = !$checkbox.prop('checked');
			$checkbox.prop('checked', isChecked);

			$card.attr('data-active', isChecked);
			this.toggleBtnDownloadDisabled();
		});

		this.$cardCheckboxInputs.on('change click', (event) => {
			event.preventDefault();
			event.stopPropagation();
		});

		this.$btnDownload = this.$el.find(`.${CLS}-btn--download`);

		this.$btnDownload.on('click', () => {
			this.downloadSelected();
		});

		this.toggleBtnDownloadDisabled();
	}

	toggleBtnDownloadDisabled() {
		let checkedItems = this.$cardCheckboxInputs.filter(':checked').length;
		if (checkedItems > 0) {
			this.$btnDownload.removeAttr('disabled');
		} else {
			this.$btnDownload.attr('disabled', 'disabled');
		}
	}

	downloadSelected() {
		let count = 0;

		this.$cardCheckboxInputs.filter(':checked').each((_index, element) => {
			let $element = $(element);
			count++;

			let src = $element.val();

			setTimeout(() => {
				let downloader = document.createElement('a');

				downloader.setAttribute('href', src);
				downloader.setAttribute('download', '');
				document.body.appendChild(downloader);
				downloader.click();
				document.body.removeChild(downloader);
			}, 500 * count);
		});
	}
}
